import type { ApplicationChoiceDto } from '../../Search/ApplicationChoice/Controller/ApplicationChoiceDto.csharp';
import type { ApplicationChoiceSearchCriteria } from '~/Features/Search/ApplicationChoice/ApplicationChoiceSearchCriteria.csharp';
import { isNotEmptyArray, isNotEmptyObject, isNotEmptyString } from '~/Partials/FormFields/validators';

export const isItemAdded = (id: string, currentChoices: ApplicationChoiceDto[]): boolean =>
    currentChoices.some(choice => choice.id === id);

export const areAllItemsAdded = (choices: ApplicationChoiceDto[], currentChoices: ApplicationChoiceDto[]): boolean =>
    choices.every(choice => isItemAdded(choice.id, currentChoices));

export const isNotEmptySearchParams = (params: any) =>
    isNotEmptyObject(params) && (isNotEmptyString(params.phrase) || isNotEmptyArray(params.levels));

/*
converts params to query string.
From: { phrase: 'test', levels: ['BAC', 'MAC'] }
To: '?phrase=test&levels=BAC&levels=MAC'
*/
export const mapSearchParamsToQueryString = ({ levels = [], phrase = '' }: ApplicationChoiceSearchCriteria) => {
    if (isNotEmptySearchParams({ levels, phrase })) {
        return [`?phrase=${phrase}`, ['', ...levels].join('&levels=')].join('');
    }

    return '';
};
